import { render, staticRenderFns } from "./Traveltickets.vue?vue&type=template&id=407222b9&scoped=true&"
import script from "./Traveltickets.vue?vue&type=script&lang=js&"
export * from "./Traveltickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407222b9",
  null
  
)

export default component.exports